import {QueryResult} from '@apollo/client';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import notifications from 'notifications';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import {ButtonStyle} from 'ui-library/buttons/Button';
import * as Colors from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import legacyRunModal from 'ui-library/legacyRunModal';
import Modal from 'ui-library/modals/Modal';
import {readableTime} from 'util/DateUtil';

import {UserTableUser} from './__generated/UserTableUser';
import * as UsersDAO from './UsersDAO';

interface Props {
  onRequestClose: () => void;
  onRequestSubmit: () => void;
  user: UserTableUser;
  onRefreshUserListing: QueryResult['refetch'];
}

export function ConfirmRemoveAPIKeyModal(props: Props): JSX.Element {
  async function handleSubmit(): Promise<void> {
    await UsersDAO.revokeAPIKeys({userId: props.user.id});
    props.onRefreshUserListing();
    notifications.success(`Successfully removed ${props.user.name}'s API Key.`);
    props.onRequestSubmit();
  }

  return (
    <Modal
      onRequestClose={props.onRequestClose}
      onRequestSubmit={handleSubmit}
      title="Confirm API key removal"
      buttons={[{text: 'Remove Key', submit: true, style: ButtonStyle.NEGATIVE}]}
    >
      Confirm you’d like to remove {props.user.name}'s API key. The user can visit their User Settings page to
      regenerate a key.
    </Modal>
  );
}

export default function ManageAPIKeyModal(props: Props): JSX.Element | null {
  function handleSubmit(): void {
    props.onRequestSubmit();
    legacyRunModal(ConfirmRemoveAPIKeyModal, {
      user: props.user,
      onRefreshUserListing: props.onRefreshUserListing,
    });
  }
  return (
    <Modal
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        handleSubmit();
      }}
      title={`Manage API Key: ${props.user.name}`}
      buttons={[{text: 'Remove Key', submit: true, style: ButtonStyle.NEGATIVE}]}
    >
      <Row>
        <Col md={8}>
          <>Manage {props.user.name}'s API Key access.</>
        </Col>
      </Row>
      <Row className="u-spacing-top">
        <Col md={8}>
          <BenchlingIcon icon="key" className={css(styles.keyIcon)} />
          <span className="u-bold-font-weight u-mini-spacing-left">{props.user.name}’s API Key</span>
          <div>
            Created: {props.user.apiKey?.createdAt ? readableTime(props.user.apiKey.createdAt) : null}
          </div>
        </Col>
      </Row>
    </Modal>
  );
}

const styles = StyleSheet.create({
  keyIcon: {
    color: Colors.GRAY_DARK,
  },
});
